import { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Keyboard, Mic } from "lucide-react";
import { useLongPress } from "@/hooks/useLongPress";
import type { AgentMode } from "./types";

interface VoiceAgentButtonProps {
  mode: AgentMode;
  isActive: boolean;
  onPress: () => void;
  onLongPress: () => void;
}

export const VoiceAgentButton = forwardRef<
  HTMLButtonElement,
  VoiceAgentButtonProps
>(function VoiceAgentButton({ mode, isActive, onPress, onLongPress }, ref) {
  const longPressHandlers = useLongPress({ onPress, onLongPress });

  return (
    <Button
      ref={ref}
      variant="ghost"
      aria-label={`Agent (${mode} mode)`}
      className={cn(
        "flex-col gap-0.5 h-auto py-1.5 px-1 rounded-md w-16 select-none",
        isActive ? "text-primary" : "text-muted-foreground",
      )}
      style={
        {
          touchAction: "none",
          WebkitTouchCallout: "none",
          userSelect: "none",
        } as React.CSSProperties
      }
      {...longPressHandlers}
    >
      {mode === "voice" ? (
        <Mic className={cn("size-6", isActive && "animate-pulse")} />
      ) : (
        <Keyboard className="size-6" />
      )}
      <span className="text-[0.6rem] font-medium">Agent</span>
      <span className="text-[0.5rem] uppercase opacity-60 absolute top-[7px]">
        {mode === "voice" ? "Voice" : "Write"}
      </span>
    </Button>
  );
});
